export const getEmailFromLocalStorage = (): string => {
    const emailFromLocalStorage =
        localStorage.getItem('popupEmail') || localStorage.getItem('email') || '';
    try {
        return JSON.parse(emailFromLocalStorage) as string;
    } catch (error) {
        return emailFromLocalStorage;
    }
};
